import * as Yup from 'yup'

export const schemaOrderDeliveryAt = (t: (key: string) => string) => ({
  shipments: Yup.array().of(
    Yup.object().shape({
      uuid: Yup.string().required(t('requiredMessage')),
      deliveredAt: Yup.string().required(t('requiredMessage')),
    }),
  ),
})
